import * as React from 'react';
import { IMedia, IPagination } from '../../interfaces';
import Axios from 'axios';
import config from '../../config';
import Pagination from '../common/Pagination';
import Serial from '../videoclub/Serial';
import { withTranslation } from 'react-i18next';
import i18n from '../../config/i18next';

interface IState {
    serials: IMedia[],
    isLoading: boolean,
    currentPage: number,
    totalPages: number,
    pages: IPagination,
    query: string
}

interface IProps {
    query: string,
    t: any
}

const CancelToken = Axios.CancelToken;
let cancel: any;


class SerialSearch extends React.Component<IProps, IState> {
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.onPageChange = this.onPageChange.bind(this);
    }

    componentWillReceiveProps(nextProps:any) {
        this.setState({
            query: nextProps.query
        }, this.componentDidMount);
    }

    public state: IState = {
        serials: [],
        isLoading: true,
        currentPage: 1,
        totalPages: 1,
        pages: null,
        query: this.props.query
    }

    onPageChange(page: number) {

        this.setState({
            currentPage: page,
            // isLoading: true,
            // serials: []
        }, async () => {
            await this.loadSerials();

        });
    }

    async loadSerials() {
        cancel && cancel();

        try {
            let response = await Axios.get((this.state.currentPage == 1 ? `${config.site}/${i18n.language}/api/serial/search?query=${this.state.query}` : `${config.site}/${i18n.language}/api/serial/search?query=${this.state.query}&${this.state.pages.pageParam}=${this.state.currentPage}`), {
                cancelToken: new CancelToken(function executor (c) {
                    cancel = c;
                })
            })
    
            if (!this._isUnmounted) {
                let totalPages = response.data.pages.pageCount;
    
                this.setState({
                    serials: response.data.serials,
                    isLoading: false,
                    totalPages: totalPages,
                    currentPage: totalPages > 0 ? this.state.currentPage : 1,
                    pages: response.data.pages
                });
            }
        } catch (err) {
            // console.log (err);
        }
        
    }

    componentDidMount() {
        this.loadSerials();
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    render() {
        const {t} = this.props;
        
        return (
            <div>
                <div className="films">
                    {this.state.isLoading && (<div className="carousel-placeholder"></div>)}
                    {!this.state.isLoading && this.state.serials.length == 0 && (<h3 className="mt-0">{t("Ничего не найдено")}</h3>)}
                    <div className="flex">
                        {this.state.serials.map((film: IMedia, index: number) => {
                            return <Serial key={index} film={film} />;
                        })}
                    </div>
                </div>
                {!this.state.isLoading && this.state.serials.length > 0 && <Pagination currentPage={this.state.currentPage} totalPages={this.state.totalPages} onChange={this.onPageChange} />}
            </div>
        );
    }
}

export default withTranslation()(SerialSearch);